import { useState } from "react";
import { Box, Button, Paper, Portal, Stack, Typography } from "@mui/material";
import FusionMsiWaitOverlay from "components/FusionMsiWaitOverlay";

/**
 * Local preview of the FusionMSI wait mark above a sample page.
 * Dev preview of the full-page FusionMSI wait used by Loading page.
 */
export default function FusionMsiWaitPreviewPage() {
  const [open, setOpen] = useState(true);
  const [playKey, setPlayKey] = useState(0);

  const show = () => {
    setPlayKey((key) => key + 1);
    setOpen(true);
  };

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        px: { xs: 2, sm: 4 },
        py: 4,
      }}
    >
      <Stack spacing={3} sx={{ maxWidth: 720, mx: "auto" }}>
        <Typography variant="h4" component="h1">
          Wait overlay preview
        </Typography>
        <Typography color="text.secondary">
          The star sits above this page. Hide it to read the page, then show it again to replay the assemble.
          Full-page waits in the app use this same mark.
        </Typography>
        {open ? null : (
          <Box>
            <Button variant="contained" onClick={show}>
              Show overlay
            </Button>
          </Box>
        )}
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Sample page
          </Typography>
          <Typography color="text.secondary">
            This stands in for an app that is still working. The scrim should dim it, and the mark should stay
            centered over it.
          </Typography>
        </Paper>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Another section
          </Typography>
          <Typography color="text.secondary">
            Buttons, lists, and maps stay underneath the same way while a full-page wait is up.
          </Typography>
        </Paper>
      </Stack>
      {open ? (
        <>
          <FusionMsiWaitOverlay key={playKey} />
          <Portal>
            <Box
              sx={{
                position: "fixed",
                bottom: 24,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: (theme) => theme.zIndex.modal + 1,
              }}
            >
              <Button variant="contained" onClick={() => setOpen(false)}>
                Hide overlay
              </Button>
            </Box>
          </Portal>
        </>
      ) : null}
    </Box>
  );
}
